/* @ngInject */

const ServicioChargebee = function ($q, $state) {

  this.obtenerSesionPortal = (cveContribuyente) => {

    Chargebee.getInstance().setPortalSession(function () {
      return $.ajax({
        url: window.location.origin + '/servicios/PortalServicio.svc/create_portal_session',
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          cveContribuyente
        })
      });
    });
  };

  this.abrirPortal = (cb) => {
    let cbPortal = Chargebee.getInstance().createChargebeePortal();
    cbPortal.open({
      close() {
        if (angular.isFunction(cb)) cb();
      }
      });
  };

  this.editarSuscription = (suscriptionId) => {
    let cbPortal = Chargebee.getInstance().createChargebeePortal();
    cbPortal.open({
    },
      {
        sectionType: Chargebee.getPortalSections().EDIT_SUBSCRIPTION,
        params: {
          subscriptionId: suscriptionId
        }
      });
  };

  const abrirCheckout = (endpoint, data, cb) => {
    const chargebeeInstance = Chargebee.getInstance();

    let cbPortal = chargebeeInstance.openCheckout({
      hostedPage: function () {

        const deferred = new $q.defer();

        $.ajax({
          url: `${window.location.origin}/servicios/PortalServicio.svc/${endpoint}`,
          method: 'POST',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(data),
          success: function (data) {
            if (!data.EsError) {
              deferred.resolve(data.Respuesta);
            } else {
              chargebeeInstance.closeAll();
            }
          },
          error: function (err) {
            chargebeeInstance.closeAll();
          }
        });

        return deferred.promise;

      },
      error: function () {
        chargebeeInstance.closeAll();
      },
      success: function () {
        if (angular.isFunction(cb)) {
          cb();
        } else {
          $state.reload();
        }
      },
      close: function () {
        if (angular.isFunction(cb)) {
          //cb();
        } else {
          $state.reload();
        }     
      }
    });
  };

  this.abrirCheckoutSuscripcion = abrirCheckout.bind(null, "create_checkout_url");

  this.abrirCheckoutTimbres = abrirCheckout.bind(null, "create_checkout_url_timbres");

};

export default ServicioChargebee;
